const Colors = {
  light: {
    dark: "#263238",
    solitude: "#EDF1F7",
    default: "#263238",
    success: "#00E096",
    warning: "#FF9200",
    white: "#ffffff",
    light: "#f2f5f8", //"#F2F2F2"
    primary: "#42C4FF",
    secondary: "#b0bec5",
    accent: "#FF9200",
    error: `#FF4C4C`,
    info: "#2196F3",
    catalina: "#2D415A",
    gunmetal: "#2C383E",
    bali_hai: "#8A959A",
    bismark: "#546E7A",
    alice_blue: "#E1F5FE",
    pale_blue: "#E4EBF3",
    sky: "#40c4ff",
    onahau: "#B6E7FF",
    water_leaf: "#B6FFE7",
    provincial_pink: "#FFE2D5",
    magnolia: "#EDE2FE",
    humming: "#CCF9EA",
    cyan: "#CBF9FF",
    carousel: "#FFDDE5",
  },
  dark: {
    white: "#0001",
    light: "#ccc",
    primary: "#2196F3",
    secondary: "#424242",
    accent: "#FF4081",
    error: "#FF4C4C",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FB8C00",
  },
};

export default Colors;
